"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import styles from "./HeroCarousel.module.scss";

const images = ["/hero/1.webp", "/hero/2.webp"];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    let transitionTimeout;

    const interval = setInterval(() => {
      setFade(false);
      transitionTimeout = setTimeout(() => {
        setIndex((current) => (current + 1) % images.length);
        setFade(true);
      }, 500);
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(transitionTimeout);
    };
  }, []);

  return (
    <div className={styles.heroImage}>
      <Image
        src={images[index]}
        alt="Geer jewellery collection"
        fill
        sizes="(max-width: 700px) 100vw, min(100vw, 1440px)"
        priority
        fetchPriority="high"
        style={{
          transition: "opacity 0.5s ease-in-out",
          opacity: fade ? 1 : 0,
        }}
      />
    </div>
  );
}
